import React from "react";
import fieldPropTypes from "./field-prop-types";

class List extends React.PureComponent {
  render() {
    const {
      field: { name, title, options, params },
      components: { Label }
    } = this.props;
    const ListComponent = params.includes("TDFieldOptionNumber") ? "ol" : "ul";
    return (
      <div
        className={`list-wrapper-web-sdk ${params.split("|").join(" ")}`}
        data-testid={`list-wrapper-${name}`}
      >
        {title && <Label name={name} text={title} />}
        <ListComponent className='list-web-sdk'>
          {options.map(option => (
            <li key={option.hasOwnProperty("text") ? option.text : option}>
              {option.hasOwnProperty("text") ? option.text : option}
            </li>
          ))}
        </ListComponent>
      </div>
    );
  }
}

List.propTypes = fieldPropTypes;

export default List;
